/**
 * @enum {string}
 */
var ContactType;
(function (ContactType) {
    ContactType["EMAIL"] = "E";
})(ContactType || (ContactType = {}));
;
export default ContactType;
